import { render } from "./PlayerSummaryScoutReportForm.vue?vue&type=template&id=22d62d03"
import script from "./PlayerSummaryScoutReportForm.vue?vue&type=script&lang=js"
export * from "./PlayerSummaryScoutReportForm.vue?vue&type=script&lang=js"

import "./PlayerSummaryScoutReportForm.vue?vue&type=style&index=0&id=22d62d03&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__